import currency from "currency.js";

export const EURO = (value: string | number) =>
  currency(value, {
    symbol: "€",
    separator: ".",
    decimal: ",",
    pattern: `# !`,
  });
